var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRakutenAiFullFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_rakuten_ai_full_filled_svg__clip0_50649_34862)",
    fill: props.color
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14 29.714L5 27.08h22.023L8.14 29.714zM11.717 25.102v-5.837h2.53l4.38 5.837h4.478l-5.292-7.046c1.65-1.185 2.732-3.107 2.732-5.289a6.497 6.497 0 00-6.494-6.49H8.14v18.822h3.576v.003zm0-15.25h2.334a2.922 2.922 0 012.918 2.915 2.927 2.927 0 01-2.918 2.919h-2.334V9.852zM23.859 2h.342l1.427 4.067h-1.77V2zM19.12 6.067v-.345l4.065-1.424v1.77H19.12zM23.185 10.805h-.342l-1.428-4.064h1.77v4.064zM27.926 6.741v.342l-4.067 1.428V6.74h4.067z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_rakuten_ai_full_filled_svg__clip0_50649_34862"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgIconRakutenAiFullFilled;